import { urls } from '../../../../../constants/constants';

export const fetchOtherStaff = (userId, pageNo, search) => {
  return new Promise((resolve, reject) => {
    fetch(
      `${
        urls.aspariaBackend
      }api/v1/patient/getPatientsByUserId?userId=${userId}&pageNo=${pageNo}&pageSize=15${search &&
        `&search=${search}`}`,
      {
        headers: {
          method: 'GET',
          accept: 'application/json',
          Authorization: `Bearer `,
        },
        credentials: 'include',
      }
    )
      .then((data) => {
        return data.json();
      })
      .then((result) => {
        resolve(result);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
